
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.3 36.967c0-.3 0-.5-.1-.8-.6-5.3-4.1-10.1-9.9-10.1-1.3 0-2.5.3-3.6.7-1-2.2-2-4.3-3-6.5-.1-.3-.2-.5-.3-.6-.5-1-.9-2-1.4-3h1.8c.5 0 1.7-.2 2.1 0-.2-.1 3.1.4.5 1.1-1 .3-.8 3.4 0 3.2 2.7-.7 3.9-4.3 1.8-6.5-1.7-1.7-5.7-.9-7.9-.9-.9 0-.7 2.2-.5 2.7l1.5 3.3H23.1c-.2-.4-.4-.8-.5-1.2h.7c2.3-.5 2.2-4.9.2-5.7-.9-.3-2-.3-2.9-.4-.8-.1-2-.4-2.8-.2-2.3.7-2.4 5.2-.3 6.2.8.3 2 .1 2.8.1h.4c.3.8.7 1.6 1 2.4-1 2-2 4.1-3 6.1-1.1-.5-2.4-.8-3.8-.8-5.8 0-9.9 5.3-9.9 10.9 0 5.4 3.8 10.5 9.5 10.9 5.8.3 9.5-4.2 10.3-9.3H27c.4 1.3 1.4 2.5 2.9 2.6 2 .1 3-1.6 3.3-3.3.1-.3.1-.7.1-.9 0-.2 0-.6-.1-1-.1-.7-.4-1.3-.8-1.9 1.8-3.8 3.6-7.5 5.4-11.3.7 1.6 1.5 3.3 2.2 4.9-3 2-4.8 5.5-4.8 9.3 0 5.4 3.8 10.5 9.5 10.9 6.1.3 9.8-4.6 10.4-10.1.2-.2.2-.5.2-.8zm-36.7-21.8h.7c-.2.1-.4.1-.7 0zm10.8 7.5h6.4c-1.6 3.4-3.3 6.8-4.9 10.2-.3-.1-.6-.1-.9-.1-.3 0-.6.1-.9.1-1.5-3.4-3-6.8-4.6-10.2 1.7.1 3.3 0 4.9 0zm-6.7.1c1.7 3.8 3.3 7.5 5 11.3-.3.4-.5.9-.7 1.3h-2.2c-.5-3.1-2.1-6-4.6-7.7.7-1.8 1.5-3.9 2.5-4.9zm-3.6 7.6c2 .9 3.6 2.6 4.2 5h-6.6c.8-1.6 1.6-3.2 2.3-4.8.1-.1.1-.1.1-.2zm-12.7 6.6c0-6.1 6.1-8.5 11-7.2-1 2-2 4-2.9 6.1-.2.5-.4 2.7.5 2.7h8.4c-2.1 8.4-17 8-17-1.6zm23.6 1c-.4 0-1.5-.4-1.8-.8v-.4c.3-.4 1.3-.8 1.7-.8.6 0 2 .4 2 1 0 .5-1.4 1-1.9 1zm6.7-1c0-3.4 1.9-5.7 4.5-6.8 1.2 2.6 2.4 5.3 3.6 7.9.7 1.5 1.3-1.4 1-2.2-.9-2.1-1.9-4.1-2.8-6.2 4.8-1 10.6 1.4 10.9 7.3-.5 10-17.2 10.1-17.2 0z"}})])
          )
        }
      }
    